export default __webpack_public_path__ + "static/media/pollice.d91240a0.svg";